/**
 * The tab for selecting ASBV value or percentile.
 */
export enum ASBVsTab {
  Values = 0,
  Percentiles = 1,
}
